/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{DataType as e}from"./enums.js";function s(s){switch(s){case e.BYTE:case e.UNSIGNED_BYTE:return 1;case e.SHORT:case e.UNSIGNED_SHORT:case e.HALF_FLOAT:return 2;case e.FLOAT:case e.INT:case e.UNSIGNED_INT:return 4}}export{s as getDataTypeBytes};
